import { ApiError } from 'errors'

import i18n from '../../../i18n'

const HTTP_ERROR_STATUS_MIN = 400

type SnackbarVariant = 'success' | 'error'

const PARKING_CONFIG_ERROR_KEYS: Record<string, string> = {
  'PARKING_CONFIG.FIXED_EXISTS': 'errors:PARKING_CONFIG.FIXED_EXISTS',
  'PARKING_CONFIG.FREE_FIXED_OVERLAP': 'errors:PARKING_CONFIG.FREE_FIXED_OVERLAP',
  'PARKING_CONFIG.ICON_REQUIRED': 'errors:PARKING_CONFIG.ICON_REQUIRED',
  'PARKING_CONFIG.INVALID': 'errors:PARKING_CONFIG.INVALID',
  'PARKING_CONFIG.TYPE_IMMUTABLE': 'errors:PARKING_CONFIG.TYPE_IMMUTABLE',
  'PARKING_CONFIG.FREE_FIXED_IMMUTABLE': 'errors:PARKING_CONFIG.FREE_FIXED_IMMUTABLE',
  'PARKING_CONFIG.VALIDITY_LOCKED': 'errors:PARKING_CONFIG.VALIDITY_LOCKED',
  'PARKING_CONFIG.STORE_REQUIRED': 'errors:PARKING_CONFIG.STORE_REQUIRED',
  'PARKING_CONFIG.TAG_REQUIRED': 'errors:PARKING_CONFIG.TAG_REQUIRED',
  'PARKING_CONFIG.QR_IDENTITY_REQUIRED': 'errors:PARKING_CONFIG.QR_IDENTITY_REQUIRED',
  'PARKING_CONFIG.QR_IDENTITY_DUPLICATE': 'errors:PARKING_CONFIG.QR_IDENTITY_DUPLICATE',
  'PARKING_CONFIG.QR_SYSTEM_INVALID': 'errors:PARKING_CONFIG.QR_SYSTEM_INVALID',
  'PARKING_CONFIG.QR_ISSUER_INVALID': 'errors:PARKING_CONFIG.QR_ISSUER_INVALID',
  'PARKING_CONFIG.QR_BENEFIT_INVALID': 'errors:PARKING_CONFIG.QR_BENEFIT_INVALID',
}

const getSnackbarVariantFromError = (err: unknown): SnackbarVariant =>
  err instanceof ApiError && err.status < HTTP_ERROR_STATUS_MIN ? 'success' : 'error'

const getParkingConfigErrorMessage = (err: unknown, fallbackKey: string): string => {
  const fallback = i18n.t(fallbackKey)

  if (!(err instanceof ApiError)) return fallback

  const errorKey = PARKING_CONFIG_ERROR_KEYS[String(err.type)]
  if (errorKey) return i18n.t(errorKey)

  if (err.message && !err.message.startsWith('errors:')) return err.message

  return fallback
}

const getParkingConfigErrorToast = (err: unknown, fallbackKey: string) => ({
  message: getParkingConfigErrorMessage(err, fallbackKey),
  variant: getSnackbarVariantFromError(err),
})

export { getParkingConfigErrorMessage, getParkingConfigErrorToast }
